var elements = document.querySelectorAll('[data-click="noclick"]');

elements.forEach(function(element) {
  element.addEventListener('click', function() {
    // Find the closest ancestor 'li' element and toggle the 'showsubmenu' class
    var closestLi = closestWithDataAttribute(this, 'li');
    if (closestLi) {
      closestLi.classList.toggle('showsubmenu');
    }
  });
});

function closestWithDataAttribute(element, tagName) { 
  while (element && element.tagName.toLowerCase() !== tagName) {
    element = element.parentElement;
  }
  return element;
}

document.querySelector('[data-click="noclick"]').addEventListener('click', function(e) {
    e.preventDefault();
});

// Click outside
var targetClass = 'showsubmenu';

document.addEventListener('click', function(event) {
  var targetElement = event.target;
  var isInsideElement = checkIfElementOrAncestorHasClass(targetElement, targetClass);

  if (!isInsideElement) {
    var elementsWithClass = document.getElementsByClassName(targetClass);

    for (var i = 0; i < elementsWithClass.length; i++) {
      elementsWithClass[i].classList.remove(targetClass);
    }
  }
});

function checkIfElementOrAncestorHasClass(element, className) {
  while (element) {
    if (element.classList.contains(className)) {
      return true;
    }
    element = element.parentElement;
  }
  return false;
}